import { Container, ContainerDataStore, ContainerStatus } from '@skinsoft/entity'
import { containerSelectors } from '@skinsoft/entity-ui'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { AddContainerModal, StateInput } from '@skinsoft/ui'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
    components: {
        sStateInput: StateInput,
        sContainerModal: AddContainerModal,
    },
    props: {
        statusesToSearch: Array,
        excludedIds: Array,
    },
    template: require('./container-input.html'),
})
export default class ContainerInput extends ReactiveVue {
    public selectedContainer: Container
    public $containerDatastore: ContainerDataStore

    public containerStatus: ContainerStatus[]

    public $refs: {
        containerModal: AddContainerModal
        stateInput: StateInput
    }

    public created() {
        this.$containerDatastore = ContainerDataStore.getInstance()
    }

    public openPopup() {
        this.$refs.containerModal.open()
    }

    public onContainerSelected(container: {id: string, type: string}) {
        this.$containerDatastore.fetchOne(container.id).subscribe(container => {
            this.selectedContainer = container
            this.$refs.stateInput.setValue(containerSelectors.identifier(this.selectedContainer) || containerSelectors.title(this.selectedContainer))
        })
        
        this.$emit('change', container)
    }
}
